export default function CircleSvg() {
  return (
    <svg
      className="tp-circle-svg"
      xmlns="http://www.w3.org/2000/svg"
      width="152"
      height="152"
      viewBox="0 0 152 152"
    >
      <path
        id="tp-cicle-path-934"
        fill="#F0EC51"
        d="M18,76a58,58,0,1,1,58,58A58,58,0,0,1,18,76"
      ></path>
      <text className="tp-circle-text">
        <textPath xlinkHref="#tp-cicle-path-934">
          STOP WISHING • START DOING
        </textPath>
      </text>
    </svg>
  );
}
